import React, { useEffect, useState } from "react";
import { Container, Card } from "./styles";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { addDays } from "date-fns";
import locale from "antd/es/date-picker/locale/pt_BR";
import dayjs from "dayjs";
import { Button, Modal, Spin, DatePicker } from "antd";
import CountUp from "react-countup";
import { getDate, getValue } from "../../../services/functions";
import { Message, ViewInput } from "../../../GlobalStyles";
import userPhoto from "../../../images/user.png";

export default function RankingFranqueados({ nameType }) {
  const [loading, setLoading] = useState(true);
  const [visibleModal, setVisibleModal] = useState(false);
  const [totalPayments, setTotalPayments] = useState(0);
  const [franqueado, setFranqueado] = useState(null);
  const [franqueados, setFranqueados] = useState([]);
  const [startDate, setStartDate] = useState(addDays(new Date(), -30));
  const [endDate, setEndDate] = useState(new Date());

  useEffect(() => {
    listFranqueados(startDate, endDate);
    window.scrollTo(0, 0);
  }, [startDate, endDate]);

  async function listFranqueados(startDate, endDate) {
    setLoading(true);
    await api
      .get(`/admin/users/ranking?date_start=${startDate}&date_end=${endDate}`)
      .then((response) => {
        setFranqueados(response.data.users);
        setTotalPayments(response.data.totalPayments);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  return (
    <Container>
      <h1>Ranking Franqueados</h1>
      {loading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <Card>
            <p>Total</p>
            <CountUp duration={1} end={franqueados.length} />
          </Card>
          {/*}  
                 <p
            style={{
              fontSize: 15,
              marginTop: 5,
              marginBottom: 10,
            }}
          >
            Faturamento total no periodo é de{" "}
            <strong>{getValue(totalPayments || 0)}</strong>
          </p>*/}
          <div className="filter">
            <ViewInput
              style={{ width: "100%", maxWidth: 265, marginRight: 15 }}
            >
              <p>Selecione o Periodo</p>
              <DatePicker.RangePicker
                placeholder={["data inicial", "data final"]}
                value={[
                  startDate ? dayjs(startDate) : "",
                  endDate ? dayjs(endDate) : "",
                ]}
                locale={locale}
                format={"DD/MM/YYYY"}
                onChange={(value, dateString) => {
                  setStartDate(getDate(dateString[0]));
                  setEndDate(getDate(dateString[1]));
                }}
                allowClear={false}
                style={{ width: 265, marginBottom: 15 }}
                onOk={() => {}}
              />
            </ViewInput>
          </div>
          <div className="orders">
            {franqueados.length == 0 && (
              <Message>Nenhum {nameType} encontrado</Message>
            )}
            {franqueados.map((item, index) => {
              return (
                <div className="order">
                  <img src={item.photo ? item.photo_url : userPhoto} />
                  <div
                    className="infos"
                    style={{
                      flex: 1,
                    }}
                  >
                    <p>
                      <strong>{index + 1}.</strong> {item.name} - {item.email}
                    </p>
                    <p
                      style={{
                        width: "100%",
                        marginTop: 5,
                      }}
                    >
                      Total em Serviços:
                      <strong> {getValue(item.totalPayment)}</strong>
                    </p>
                    <p
                      style={{
                        width: "100%",
                        marginTop: 5,
                        marginBottom: 5,
                      }}
                    >
                      Média de Faturamento:
                      <strong> {getValue(item.totalPayment * 3)}</strong>
                    </p>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        justifyContent: "space-between",
                      }}
                    >
                      <p
                        style={{
                          width: "50%",
                        }}
                      >
                        Total de Serviços:
                        <strong> {item.totalServices}x</strong>
                      </p>
                      <p
                        style={{
                          width: "50%",
                        }}
                      >
                        Total de Urgência:
                        <strong> {item.totalUrgency}x</strong>
                      </p>
                    </div>
                  </div>
                  <div className="actions">
                    <Button
                      type="primary"
                      onClick={() => {
                        setFranqueado(item);
                        setVisibleModal(true);
                      }}
                    >
                      Ver serviços
                    </Button>
                  </div>
                </div>
              );
            })}

            <Modal
              title={franqueado?.servicesPeriod.length + " Tipos de serviços"}
              width={500}
              open={visibleModal}
              cancelText="FECHAR"
              okButtonProps={{
                style: {
                  display: "none",
                },
              }}
              onCancel={() => {
                setVisibleModal(false);
              }}
            >
              <div
                style={{
                  paddingTop: 0,
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    maxHeight: 400,
                    margin: "15PX 0",
                    overflowY: "auto",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      color: "#000",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "left",
                      marginBottom: 10,
                    }}
                  >
                    {franqueado?.servicesPeriod.map((item, index) => {
                      return (
                        <div
                          style={{
                            display: "flex",
                            marginBottom: 4,
                            width: "100%",
                            paddingRight: 10,
                            justifyContent: "space-between",
                          }}
                        >
                          <p style={{ flex: 1 }}>
                            {index + 1}. {item.name}
                          </p>
                          <p>
                            {item.amount}x {getValue(item.value)}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </Modal>
          </div>
        </>
      )}
    </Container>
  );
}
